export const StepName = ['Waarvoor afspraak', 'Jouw situatie', 'Jouw gegevens', 'Bedankt'];

export enum ReasonAnalytics {
    REASON_EVENT = 'Keuze waarmee',
    HOUSING_EVENT = 'Keuze aankoop',
    REFINANCE_EVENT = 'Renteaanbod',
    CTA_EVENT = 'Contact icoon',
    FIRST_HOUSE = 'Eerste huis',
    NEXT_HOUSE = 'Ander huis',
    ADJUST_MORTGAGE = 'Hypotheek',
    REFINANCE_MORTGAGE = 'Oversluiten',
    DIFFERENT_QUESTION = 'Andere vraag',
    ACCEPTED = 'Geaccepteerd',
    ORIENTATING = 'Oriënteren',
    OFFER = 'Bieden',
    YES = 'Ja',
    NO = 'Nee'
}
